const defaultParams = {
  offset: 0
};

const mergeDefaultParams = params => ({ ...defaultParams, ...params });

export default mergeDefaultParams;
